"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = kofiColors;
var colors = {
  kofiWhite: "#FFF",
  kofiBlack: "#000",
  kofiRed: "#FF5E5B",
  kofiBlue: "#13C3FF",
  kofiYellow: "#FBAA19",
  kofiGrey: "#434B57"
};

function kofiColors(color) {
  return colors[color] ? colors[color] : color;
}